import PLAYER from '../playerData';
import { STORY_BEATS, MAPS } from '../data';

export class MapSimulation {
  constructor() {
    this.grid = Array(5).fill().map(() => Array(5).fill(null));
    
    // Initialize map data if not already set
    if (!PLAYER.buildings || !PLAYER.decorations) {
      const mapTemplate = MAPS.STARTING_VILLAGE;
      
      // Initialize buildings
      PLAYER.buildings = {};
      Object.entries(mapTemplate.buildings).forEach(([key, building]) => {
        PLAYER.buildings[key] = {
          ...building,
          built: false
        };
      });
      
      // Initialize decorations
      PLAYER.decorations = [...mapTemplate.decorations];
    }
    
    this.buildings = PLAYER.buildings;
    this.decorations = PLAYER.decorations;
    this.selectedBuilding = null;
    this.currentStoryBeat = null;
    
    // Initialize grid with buildings
    Object.values(this.buildings).forEach(building => {
      this.grid[building.row][building.col] = building;
    });

    // Check initial story triggers
    this.checkStoryTriggers('GAME_START');
  }

  update() {
    // Future: Add building state updates
  }

  selectBuilding(buildingId) {
    const building = this.buildings[buildingId];
    if (!building) return;
    
    this.selectedBuilding = building;
  }

  canBuildBuilding(building) {
    if (building.built) return false;
    if (PLAYER.resources.stars < building.starCost) return false;
    return true;
  }

  buildBuildingWithStars(buildingId) {
    const building = this.buildings[buildingId];
    if (!building || !this.canBuildBuilding(building)) return false;
    
    // Deduct stars
    PLAYER.resources.stars -= building.starCost;
    
    // Mark building as built
    building.built = true;

    // Check for story triggers
    if (building.storyBeatId) {
      this.checkStoryTriggers('BUILDING_COMPLETE', building);
    }
    
    return true;
  }

  buildBuilding(building) {
    if (!this.canBuildBuilding(building)) return false;
    
    const gameBoard = PLAYER.gameBoard;
    const requirements = building.requirements;
    
    // Remove required items
    requirements.forEach(req => {
      let remainingCount = req.count;
      for (let i = 0; i < gameBoard.length && remainingCount > 0; i++) {
        const item = gameBoard[i];
        if (item && item.name === req.name) {
          gameBoard[i] = null;
          remainingCount--;
        }
      }
    });
    
    // Mark building as built
    building.built = true;

    // Check for story triggers
    if (building.storyBeatId) {
      this.checkStoryTriggers('BUILDING_COMPLETE', building);
    }
    
    return true;
  }

  checkStoryTriggers(triggerType, triggerValue) {
    Object.values(STORY_BEATS).forEach(beat => {
      // Skip if already shown
      if (PLAYER.storyBeatsShown.includes(beat.id)) return;

      // Check if trigger matches
      if (
        (triggerType === 'GAME_START' && beat.id === 'GAME_START') ||
        (beat.trigger?.type === triggerType && beat.trigger?.buildingId === triggerValue?.id)
      ) {
        this.currentStoryBeat = beat;
        // Don't add to shown beats here - wait until explicitly dismissed
      }
    });
  }

  dismissStoryBeat() {
    if (this.currentStoryBeat && !PLAYER.storyBeatsShown.includes(this.currentStoryBeat.id)) {
      PLAYER.storyBeatsShown.push(this.currentStoryBeat.id);
    }
    this.currentStoryBeat = null;
  }
}
